<template>
  <div class="text-h5">{{ remainingTimeStr }}</div>
</template>

<script>
export default {
  name: 'Countdown',
  props: {
    timeInMinutes: Number,
  },
  mounted() {
    console.debug('mounted Countdown');
    this.interval = setInterval(() => {
      this.remainingTimeSeconds--;
      if (this.remainingTimeSeconds <= 0) {
        clearInterval(this.interval);
        this.$emit('onTimerExpired');
      }
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  data() {
    return {
      remainingTimeSeconds: this.timeInMinutes * 60,
      interval: null,
    };
  },
  computed: {
    remainingTimeStr() {
      let minutes = Math.floor(this.remainingTimeSeconds / 60);
      let seconds = this.remainingTimeSeconds % 60;

      let str = '';
      if (minutes < 10) str = '0';
      str += `${minutes}:`;

      if (seconds < 10) str += '0';
      str += `${seconds}`;
      return str;
    },
  },
};
</script>
